// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-script_footer__ECHzo"};